import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 13 13\" id=\"add\"><path d=\"M12.295 5.593H7.407V.705C7.407.483 7.105 0 6.5 0s-.907.483-.907.705v4.888H.705C.483 5.593 0 5.895 0 6.5s.483.907.705.907h4.888v4.888c0 .222.302.705.907.705s.907-.483.907-.705V7.407h4.888c.222 0 .705-.302.705-.907s-.483-.907-.705-.907Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol